/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentParcelsParcelidSerialsQueryResponse,
  GetApiV1IndividualpaymentParcelsParcelidSerialsPathParams,
  GetApiV1IndividualpaymentParcelsParcelidSerials401,
  GetApiV1IndividualpaymentParcelsParcelidSerials500,
} from "../../types/individualPaymentParcelsController/GetApiV1IndividualpaymentParcelsParcelidSerials.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentParcelsParcelidSerials } from "../../clients/individualPaymentParcelsController/getApiV1IndividualpaymentParcelsParcelidSerials.ts";

export const getApiV1IndividualpaymentParcelsParcelidSerialsQueryKey = (
  parcelId: GetApiV1IndividualpaymentParcelsParcelidSerialsPathParams["parcelId"],
) =>
  [
    {
      url: "/api/v1/individualpayment/parcels/:parcelId/serials",
      params: { parcelId: parcelId },
    },
  ] as const;

export type GetApiV1IndividualpaymentParcelsParcelidSerialsQueryKey =
  ReturnType<typeof getApiV1IndividualpaymentParcelsParcelidSerialsQueryKey>;

export function getApiV1IndividualpaymentParcelsParcelidSerialsQueryOptions(
  parcelId: GetApiV1IndividualpaymentParcelsParcelidSerialsPathParams["parcelId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1IndividualpaymentParcelsParcelidSerialsQueryKey(parcelId);
  return queryOptions<
    GetApiV1IndividualpaymentParcelsParcelidSerialsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentParcelsParcelidSerials401
      | GetApiV1IndividualpaymentParcelsParcelidSerials500
    >,
    GetApiV1IndividualpaymentParcelsParcelidSerialsQueryResponse,
    typeof queryKey
  >({
    enabled: !!parcelId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentParcelsParcelidSerials(parcelId, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os seriais registrados da parcela com situação, estação, ticket, linha digitável e cancelamento. Migrado do legado IndividualPayment/LoadGridDataAsyncPaymentSerial. **(Requer Authorization para autenticação)**
 * @summary Retorna os seriais de pagamento (boletos) de uma parcela (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/serials}
 */
export function useGetApiV1IndividualpaymentParcelsParcelidSerials<
  TData = GetApiV1IndividualpaymentParcelsParcelidSerialsQueryResponse,
  TQueryData = GetApiV1IndividualpaymentParcelsParcelidSerialsQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentParcelsParcelidSerialsQueryKey,
>(
  parcelId: GetApiV1IndividualpaymentParcelsParcelidSerialsPathParams["parcelId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentParcelsParcelidSerialsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentParcelsParcelidSerials401
          | GetApiV1IndividualpaymentParcelsParcelidSerials500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentParcelsParcelidSerialsQueryKey(parcelId);

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentParcelsParcelidSerialsQueryOptions(
        parcelId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentParcelsParcelidSerials401
      | GetApiV1IndividualpaymentParcelsParcelidSerials500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
